import axios from 'axios';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import HTMLReactParser from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import Sidebar from './Sidebar';
import NavBar from '../element/NavBar';
import Footer from '../element/Footer';
// helpers
import { logOutIfTokenExpired } from '../helpers';

const MyProfileNew = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');
  const employerId = Cookies.get('employer_id');

  const [loading, setLoading] = useState(true);
  const [profileData, setProfileData] = useState([]);

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(BaseApi + '/users/myaccount', null, {
        headers: {
          key: ApiKey,
          token: tokenKey,
          'Content-Type': 'application/json',
        },
      });

      setLoading(false);

      if(response.data.status === 200) {
        setProfileData(response.data.response);
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Cannot get profile data!', error);
    }
  };

  useEffect(() => {
    if (userType === 'candidate' || !tokenKey) {
      navigate('/user/employerlogin');
    } else {
      getData();
      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); //eslint-disable-line

  return (
    <>
      <NavBar />
      <div className='container myProfile'>
        <div className='row'>
          <div className='col-lg-3'>
            <Sidebar />
          </div>
          {
            loading
              ? (
                <div className='loader-container'></div>
              ) : (
                <>
                  <div className='col-lg-9 mb-5'>
                    <div className='d-flex'>
                      <img src='/Images/employerSide/icon14color.png' alt='' />
                      <h3 className='mx-2'>{t('employerMyProfile.companyProfile')}</h3>
                    </div>
                    <section className='myProfileEmployerBodyTopSection'>
                      <h2>{t('employerMyProfile.planDetails')}</h2>
                      <div className='mb-4'>
                        <div className='row mb-2'>
                          <div className='col-md-3 fw-bold'>
                            {t('employerMyProfile.planName')}
                          </div>
                          <div className='col-md-9 text-muted standartListStyle'>
                            {profileData.plan_name}
                          </div>
                        </div>
                        <div className='row mb-2'>
                          <div className='col-md-3 fw-bold'>
                            {t('employerMyProfile.noJobPost')}
                          </div>
                          <div className='col-md-9 text-muted standartListStyle'>
                            {
                              profileData?.AvailbleplanFeature?.availableJobpost === '1000000'
                                ? t('employerMyProfile.unlimited')
                                : profileData?.AvailbleplanFeature?.availableJobpost
                                  ? profileData?.AvailbleplanFeature?.availableJobpost
                                  : t('employerMyProfile.buyPlanPlaceholder')
                            }
                          </div>
                        </div>
                      </div>
                      <Link to='/plans/purchase' class='btn button1'>
                        {t('employerInnerAccountdetail.upgradePlan')}
                      </Link>
                    </section>
                    <div className='myProfileEmployerBody'>
                      <div className='card cardOne'>
                        <div className='companyDetails'>
                          <div className='companyDetailsBox'>
                            <div className='profileImageBox'>
                              <img
                                alt='company logo'
                                className='profileImage'
                                src={profileData.company_logo ? profileData.company_logo : '/Images/jobseekerSide/dummy-profile.png'}
                              />
                            </div>
                            <div className='card-title mb-0'>
                              <h4>{profileData.company_name}</h4>
                              <p>
                                {t('employerMyProfile.industry')}
                                {': '}
                                {
                                  profileData?.industry
                                    ? profileData?.industry.map(i => i.label).join('; ')
                                    : t('employerMyProfile.notSpecified')
                                }
                              </p>
                              <p className='text-muted'>
                                {t('employerMyProfile.joined')}
                                {' '}
                                {profileData.created}
                              </p>
                            </div>
                          </div>
                          <div>
                            <Link
                              to='/user/editprofile'
                              className='cardOneEditButton'
                            >
                              <i className='fa-solid fa-pen-to-square' />{' '}
                              {t('employerMyProfile.edit')}
                            </Link>
                          </div>
                        </div>
                        <hr style={{ opacity: 1, color: '#EBEBEB', marginTop: '28px', marginBottom: '28px' }} />
                        <div className='companyInfo'>
                          <h2>{t('employerMyProfile.companyInfo')}</h2>
                          <div className='row mb-2'>
                            <div className='col-md-3 fw-bold'>
                              {t('employerMyProfile.companyId')}:
                            </div>
                            <div className='col-md-9 text-muted'>
                              {employerId}
                            </div>
                          </div>
                          <div className='row mb-2'>
                            <div className='col-md-3 fw-bold'>
                              {t('employerMyProfile.companyName')}:
                            </div>
                            <div className='col-md-9 text-muted'>
                              {profileData.company_name}
                            </div>
                          </div>
                          <div className='row mb-2'>
                            <div className='col-md-3 fw-bold'>
                              {t('employerMyProfile.url')}:
                            </div>
                            <div className='col-md-9 text-muted'>
                              <a href={profileData.url} target='blank'>
                                {profileData.url}
                              </a>
                            </div>
                          </div>
                          <div className='row mb-2'>
                            <div className='col-md-3 fw-bold'>
                              {t('employerMyProfile.companyContactNumber')}:
                            </div>
                            <div className='col-md-9 text-muted'>
                              <a href={`tel:${profileData.company_contact}`}>
                                {profileData.company_contact}
                              </a>
                            </div>
                          </div>
                          <div className='row mb-2'>
                            <div className='col-md-3 fw-bold'>
                              {t('employerMyProfile.location')}:
                            </div>
                            <div className='col-md-9 text-muted'>
                              {profileData.location}
                            </div>
                          </div>
                          <div className='row mb-2'>
                            <div className='col-md-3 fw-bold'>
                              {t('employerMyProfile.address')}:
                            </div>
                            <div className='col-md-9 text-muted'>
                              {profileData.address}
                            </div>
                          </div>
                          <div className='row'>
                            <div className='col-md-3 fw-bold'>
                              {t('employerMyProfile.aboutCompany')}:
                            </div>
                            <div className='col-md-9 text-muted standartListStyle'>
                              {profileData.company_about && (HTMLReactParser(profileData.company_about))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )
          }
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MyProfileNew;
